import { REFRESH_COLOURS } from '../pedigree-sidebar/SidebarSection';
import {
  SURFACE_GREY,
  FIELD_BORDER
} from '../pedigree-sidebar/sections/clinical-notes-section/recordCardStyles';
import { DEFAULT_ACCENT } from '../pedigree-sidebar/sections/AddRelativePanel/tileTheme';
import { OTHER_DIAGNOSIS } from 'src/util/util';

export const ACCENT_FALLBACK = DEFAULT_ACCENT;

export const OTHER_FILL = OTHER_DIAGNOSIS.color;

export const CHROME = {
  surface: 'background.paper',
  header: SURFACE_GREY,
  border: FIELD_BORDER,
  hairline: REFRESH_COLOURS.hairline,
  text: REFRESH_COLOURS.label,
  muted: REFRESH_COLOURS.summary
};

export const INK = {
  surface: '#0F1E26',
  gutter: '#16272F',
  line: '#1B2E38',
  dim: '#5A7784',
  text: '#DCE8ED'
};

export const MONO =
  "ui-monospace, SFMono-Regular, 'Roboto Mono', Menlo, Consolas, monospace";

export const MICRO_LABEL = {
  fontSize: '0.65rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase'
};

export const PANEL_WIDTH = 380;

export const PANEL_WIDTH_REVIEW = 760;

export const PREVIEW_HEIGHT = 380;
